// reducers/joke/index.js

import { combineReducers } from 'redux';
import { joke }            from './joke';
import { jokeHasErrored }  from './joke';
import { jokeIsLoading }   from './joke';

const jokeReducers = combineReducers({
  joke,
  jokeHasErrored,
  jokeIsLoading
});

export default combineReducers({
  joke: jokeReducers
});